// Chat Roles (primarily used to determine avatar color)
export const SENDER                       = 'sender';
export const RECEIVER                     = 'receiver';
